import React, { useState, useEffect } from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import './OnlineStatus.css';

const OnlineStatus = () => {
  const { isOnline, isBackendAvailable, lastCheck } = useOnlineStatus();
  const [queueSize, setQueueSize] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const updateQueueSize = () => {
      try {
        const queue = JSON.parse(localStorage.getItem('frappe_offline_api_queue') || '[]');
        setQueueSize(queue.length);
      } catch (error) {
        console.error('Error reading offline queue:', error);
      }
    };

    // Initial check
    updateQueueSize();

    // Listen for localStorage changes
    const handleStorageChange = (event) => {
      if (event.key === 'frappe_offline_api_queue') {
        updateQueueSize();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Check periodically in case localStorage changes from same tab
    const interval = setInterval(updateQueueSize, 2000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const handleCounterClick = () => {
    if (queueSize > 0) {
      // Try to process the queue manually
      import('../utils/offlineApiQueue').then(({ offlineApiQueue }) => {
        console.log('🔄 Manual queue processing triggered from UI');
        offlineApiQueue.processQueue();
      });
      
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 3000);
    }
  };

  // Determine overall status: both network and backend must be available
  const isFullyOnline = isOnline && isBackendAvailable;
  const statusText = !isOnline 
    ? 'Offline' 
    : !isBackendAvailable 
      ? 'Offline' 
      : 'Online';

  return (
    <div className="online-status-container">
      <div 
        className={`status-dot ${isFullyOnline ? 'online' : 'offline'}`}
        title={`Status: ${statusText}${lastCheck ? ` (Last checked: ${lastCheck.toLocaleTimeString()})` : ''}`}
      ></div>
      <span className="status-text">{statusText}</span>
      
      {queueSize > 0 && (
        <div className="pending-counter-container">
          <div 
            className="pending-counter"
            onClick={handleCounterClick}
            title="Click to see details"
          >
            {queueSize}
          </div>
          {showTooltip && (
            <div className="pending-tooltip">
              {queueSize === 1 ? '1 action pending' : `${queueSize} actions pending`} to be synced. Click to retry now.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OnlineStatus;